import { Lock, OctagonX, ShieldAlert, TrendingDown } from 'lucide-react'

export const REASON_CARDS = [
  {
    id: 'stop-paying-channels-you-dont-watch',
    icon: OctagonX,
    title: 'Stop Paying for Channels You Don’t Watch',
    description:
      'NBCU is spinning off certain channels into a new company called Versant on January 1, 2026. But they are trying to lock Fubo into a multi-year contract to carry them. Why? To drive up the price and make you pay for them now while they can.',
    color: 'red',
    hoverColor: 'red',
  },
  {
    id: 'you-deserve-cheaper-flexible-packages',
    icon: TrendingDown,
    title: 'You Deserve Cheaper, Flexible Packages',
    description:
      'We want to offer you “Fubo Sports” — a lower-priced plan focused purely on the sports you love. NBCU is blocking this option. They are demanding we bundle expensive, non-sports entertainment channels into your plan, which would force us to raise your price.',
    color: 'green',
    hoverColor: 'green',
  },
  {
    id: 'why-cant-you-access-peacock-on-fubo',
    icon: Lock,
    title: 'Why Can’t You Access Peacock on Fubo?',
    description:
      'We want to make your life easier by letting you subscribe to Peacock directly through Fubo, keeping all your content on one bill. NBCU allows this on other platforms but is blocking Fubo customers from having the same convenience. We are fighting for your right to a seamless viewing experience.',
    color: 'blue',
    hoverColor: 'blue',
  },
  {
    id: 'picking-winners-losers',
    icon: ShieldAlert,
    title: 'We Are Drawing the Line at “Big Cable” Tactics',
    description:
      'You cut the cord to escape high fees and bloated bundles. NBCU is trying to drag you back to the old days of paying for channels you never watch. We are standing firm to ensure the future of streaming remains flexible, fair, and affordable for you.',

    color: 'purple',
    hoverColor: 'purple',
  },
]
